import { render, staticRenderFns } from "./SaveVersionPopup.vue?vue&type=template&id=72ae3ba6&scoped=true"
import script from "./SaveVersionPopup.vue?vue&type=script&lang=js"
export * from "./SaveVersionPopup.vue?vue&type=script&lang=js"
import style0 from "./SaveVersionPopup.vue?vue&type=style&index=0&id=72ae3ba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae3ba6",
  null
  
)

export default component.exports